var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.81 16.95C10.62 16.95 10.43 16.88 10.28 16.73L8.78 15.23C8.49 14.94 8.49 14.46 8.78 14.17C9.07 13.88 9.55 13.88 9.84 14.17L10.81 15.14L14.28 11.67C14.57 11.38 15.05 11.38 15.34 11.67C15.63 11.96 15.63 12.44 15.34 12.73L11.34 16.73C11.2 16.88 11 16.95 10.81 16.95Z",
    fill: "#5D9FE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7087 3.32445C16.4356 1.25 14.8739 1.25 14 1.25H10C9.12491 1.25 7.56014 1.25 7.29019 3.33296C3.71756 3.72043 2.25 5.69953 2.25 10.0001V16.0001C2.25 20.1701 3.38 22.7501 9 22.7501H15C20.62 22.7501 21.75 20.1701 21.75 15.9901V9.99005C21.75 5.69851 20.2821 3.71998 16.7087 3.32445ZM14 6.75H10C9.14851 6.75 7.64404 6.75 7.31482 4.83106C4.95339 5.10804 3.75 6.15562 3.75 10.0001V16.0001C3.75 19.7001 4.48 21.2501 9 21.2501H15C19.52 21.2501 20.25 19.7001 20.25 16.0001V10.0001C20.25 6.16757 19.0541 5.11458 16.7072 4.83366C16.5785 5.74237 16.0633 6.75 14 6.75ZM15.25 4.05274C15.2496 4.99927 15.2275 5.25 14 5.25H10C9.02604 5.25 8.75862 5.25 8.75021 4.05978C8.75117 4.03685 8.75112 4.01364 8.75001 3.99017C8.75137 2.75 9.0126 2.75 10 2.75H14C14.9848 2.75 15.2473 2.75 15.25 3.98049C15.2488 4.00477 15.2488 4.02887 15.25 4.05274Z",
    fill: "#5D9FE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardTick);
export default __webpack_public_path__ + "static/media/Clipboard_Tick.7cba3f91ef117dc276816c4a5707c0db.svg";
export { ForwardRef as ReactComponent };